export default __webpack_public_path__ + "static/media/dashboard-dark.3d4ee5db.svg";